import ViewBillingPage from 'components/viewBilling/ViewBilling.component';

const ViewBilling = () => {
	return <ViewBillingPage />;
};

export default ViewBilling;
